import { KeyboardEvent } from 'react'
import { DefaultTheme } from 'styled-components'
import { SharedWrapper } from 'components/shared/RadioButtons/styles'
import RadioInput from 'components/shared/Radio/input'
import Box from 'components/shared/Box'
import Text from 'components/shared/Text'
import { useResolutions } from 'store/resolutions'
import { Zone } from 'store/api-slice/types'
import { DiscountBadge } from 'components/shared/DiscountBadge'
import { HighlightDto } from 'store/api-slice/hooks'
import { useZones } from 'utils/hooks/useZones'

interface ZoneTypeRadioProps {
    option: string
    id: string
    isChecked: boolean
    label: string
    zone: Zone
    onClick: () => void
    theme?: DefaultTheme
    testId?: string
    highlight?: HighlightDto | null
}

const ZoneTypeRadio = ({
    option,
    id,
    isChecked,
    label,
    zone,
    onClick,
    theme,
    testId,
    highlight,
}: ZoneTypeRadioProps) => {
    const hasDarkMode = theme?.mode === 'dark'

    const { isTablet } = useResolutions()
    const { logotypes } = useZones({
        zone,
        mode: hasDarkMode ? 'dark' : 'light',
    })

    const getLabel = () => {
        if (isTablet) {
            if (zone === 'jamango') return 'Jamango'
            if (zone === 'relax') return 'Jamango, Relax'
            if (zone === 'saunaria') return 'Jamango, Relax, Saunaria'
        }
        return label
    }

    const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) =>
        event.key === 'Enter' && onClick()

    return (
        <SharedWrapper
            direction="row"
            align="center"
            justify="space-between"
            isChecked={isChecked}
            onClick={onClick}
            onKeyDown={handleKeyDown}
            theme={theme}
            data-testid={testId}
        >
            <Box direction="row" align="center" gap={12}>
                <RadioInput
                    option={option}
                    id={id}
                    isChecked={isChecked}
                    name={testId}
                />
                <Text
                    variant={isChecked ? 'bodyStrong' : 'body'}
                    color={hasDarkMode ? 'grayscale_200' : 'grayscale_900'}
                    align="center"
                >
                    {getLabel()}
                </Text>
                {!!highlight && <DiscountBadge element={highlight} />}
            </Box>

            {!isTablet && (
                <Box direction="row" align="center" gap={35}>
                    {logotypes.map((item, index) => (
                        <img src={item} alt="zone logo" key={index} />
                    ))}
                </Box>
            )}
        </SharedWrapper>
    )
}

export default ZoneTypeRadio
